module.exports = __webpack_public_path__ + "img/arvore.6c369760.svg";